import axios from 'axios'
import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const ACTIONS_ENDPOINT = `${API_BASE}actions/`

export default class ActionAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new ActionAPI(cls)
  }

  list({ pagination, filters }) {
    const filtersMap = {
      // Pagination
      page: ApiFilter.create({ key: 'page' }),
      pageSize: ApiFilter.create({ key: 'page_size' }),

      // Sorting
      ordering: ApiFilter.create({ key: 'ordering' }),

      // Filtering
      request: ApiFilter.create({ key: 'request' }),
      actionType: ApiFilter.create({ key: 'action_type' }),
      requestStatus: ApiFilter.create({ key: 'request___status' }),
      categoryName: ApiFilter.create({ key: 'category_name' }),
      excludeCategoryName: ApiFilter.create({ key: 'exclude_category_name' }),
    }

    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(filtersMap, { ...pagination, ...filters }),
    }
    const promise = axios
      .get(ACTIONS_ENDPOINT, options)
      .then(res => ({
        ...res.data,
        results: res.data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'List Action API Error' }))
    return promise
  }
}
